import * as React from 'react'
import Paper from '@material-ui/core/Paper'
import { ViewState } from '@devexpress/dx-react-scheduler'

import * as Moment from 'moment'
import { extendMoment } from 'moment-range'
import {
  Scheduler,
  WeekView,
  Appointments,
  Toolbar,
  DateNavigator,
  TodayButton,
  AppointmentTooltip,
} from '@devexpress/dx-react-scheduler-material-ui'
import { DateTimeInput, SelectInput, BooleanInput, required, useDataProvider } from 'react-admin'
import { useState } from 'react'
import { useFormState } from 'react-final-form'
import FormRow from '../../../../components/FormRow'
import FormCol from '../../../../components/FormCol'
import StyledInput from '../../../../components/StyledInput'
import { optionRendererRunner } from '../../../../services/misc'
const moment = extendMoment(Moment)
const currentDate = moment()

// eslint-disable-next-line no-empty-pattern
export const RunnersSchedule = ({}) => {
  const { values } = useFormState()
  const dataProvider = useDataProvider()

  const [showCalendar, setShowCalendar] = useState(false)
  const [events, setEvents] = useState([])
  const [runners, setRunners] = useState([])
  const [schedulerData, setSchedulerData] = useState([])
  const [runnerSelected, setRunnerSelected] = useState(false)

  React.useEffect(() => {
    if (values.property_id) {
      dataProvider
        .getList('runners', { filter: { property_id: values.property_id, status: 'active' }, pagination: {} })
        .then(({ data }) => {
          setRunners(data)
        })
    } else {
      setRunners([])
    }
  }, [values.property_id])

  React.useEffect(() => {
    if (values.runner_id) {
      setRunnerSelected(true)
      setEvents(runners.filter((runner) => runner.id == values.runner_id)[0]?.events?.filter((ev) => ev.status !== 'deleted'))
      setShowCalendar(true)
    } else {
      setShowCalendar(false)
    }
  }, [values.runner_id])

  React.useEffect(() => {
    setSchedulerData(
      events?.map((event) => ({
        title: event.description ? event.subject + ' (' + event.description + ')' : event.subject,
        startDate: event.start_date_time,
        endDate: event.end_date_time,
        allDay: event.is_all_day,
      })),
    )
  }, [events])

  const [currentViewName, setCurrentViewName] = useState('week')

  const currentViewNameChange = (currentViewName) => {
    setCurrentViewName(currentViewName)
  }

  const validateWhen = (selectedWhen) => {
    const endDate = moment(selectedWhen).add(30, 'minutes')
    return events.some((event) => hasOverlapStart(event, selectedWhen, endDate))
  }

  const validateDuration = (selectedDuration) => {
    const endDate = moment(values?.start_date_time).add(selectedDuration, 'minutes')
    return events.some((event) => hasOverlapStart(event, values?.start_date_time, endDate))
  }

  const hasOverlapStart = (event, newStart, newEnd) => {
    const eventStartDate = moment(event.start_date_time)
    const eventEndDate = moment(event.end_date_time)
    const newEventStartDate = moment(newStart)
    const newEventEndDate = moment(newEnd)
    const range1 = moment.range(eventStartDate, eventEndDate)
    const range2 = moment.range(newEventStartDate, newEventEndDate)
    return range1.intersect(range2) || range2.intersect(range1)
  }

  return (
    <>
      <FormRow>
        <FormCol>
          <StyledInput
            component={SelectInput}
            choices={runners}
            source="runner_id"
            optionText={optionRendererRunner}
            validate={[required()]}
            label="Choose runner"
          />
        </FormCol>
        {runnerSelected && (
          <>
            <FormCol>
              <StyledInput
                component={DateTimeInput}
                ampm={false}
                locale={'it-IT'}
                source="start_date_time"
                label="Quando"
                validate={[required(), validateWhen]}
                options={{ format: 'DD/MM/YYYY, HH:mm:ss', ampm: false, clearable: true }}
                required
              />
            </FormCol>
            <FormCol>
              <StyledInput
                component={SelectInput}
                source="duration_in_min"
                choices={[
                  { id: '30', name: '00:30' },
                  { id: '60', name: '01:00' },
                  { id: '90', name: '01:30' },
                  { id: '120', name: '02:00' },
                  { id: '150', name: '02:30' },
                  { id: '180', name: '03:00' },
                ]}
                label="Duration"
                initialValue="60"
                validate={[required(), validateDuration]}
              />
            </FormCol>
          </>
        )}
      </FormRow>
      {runnerSelected && (
        <FormRow>
          <FormCol>
            <BooleanInput label="Mostra calendario" source="iwanttoseecalendar" />
          </FormCol>
        </FormRow>
      )}
      {showCalendar && values?.iwanttoseecalendar && (
        <Paper elevation={1}>
          <Scheduler data={schedulerData}>
            <ViewState
              defaultCurrentDate={currentDate}
              currentViewName={currentViewName}
              onCurrentViewNameChange={currentViewNameChange}
            />

            <WeekView name="week" cellDuration={120} startDayHour={6} endDayHour={22} />
            <Toolbar />
            <DateNavigator />
            <TodayButton />
            <Appointments />
            <AppointmentTooltip showDeleteButton={false} showOpenButton={false} showCloseButton />
          </Scheduler>
        </Paper>
      )}
    </>
  )
}
